/** Normalize compliance deadline to YYYY-MM-DD for storage. */
export function normalizeComplianceDeadline(value) {
  if (!value) return "";
  const raw = String(value).trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  // MM/DD/YYYY or M/D/YYYY
  const slash = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slash) {
    const m = parseInt(slash[1], 10);
    const d = parseInt(slash[2], 10);
    const y = parseInt(slash[3], 10);
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
      return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    return "";
  }

  const dt = new Date(raw);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Display YYYY-MM-DD as MM/DD/YYYY. */
export function isoToMMDDYYYY(iso) {
  const normalized = normalizeComplianceDeadline(iso);
  if (!normalized) return "";
  const [y, m, d] = normalized.split("-");
  return `${m}/${d}/${y}`;
}

/** Reminder date = deadline minus 2 calendar days (YYYY-MM-DD). */
export function complianceReminderDateIso(deadlineIso) {
  const normalized = normalizeComplianceDeadline(deadlineIso);
  if (!normalized) return "";
  const [y, m, d] = normalized.split("-").map((n) => parseInt(n, 10));
  const dt = new Date(y, m - 1, d);
  if (Number.isNaN(dt.getTime())) return "";
  dt.setDate(dt.getDate() - 2);
  const ry = dt.getFullYear();
  const rm = String(dt.getMonth() + 1).padStart(2, "0");
  const rd = String(dt.getDate()).padStart(2, "0");
  return `${ry}-${rm}-${rd}`;
}

export function formatDeadlineLabel(iso) {
  return isoToMMDDYYYY(iso) || "";
}
